export default "__VITE_ASSET__BuiXfHFI__"